import { render, staticRenderFns } from "./index-grid.vue?vue&type=template&id=13007121&scoped=true&"
import script from "./index-grid.vue?vue&type=script&lang=js&"
export * from "./index-grid.vue?vue&type=script&lang=js&"
import style0 from "./index-grid.vue?vue&type=style&index=0&id=13007121&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13007121",
  null
  
)

export default component.exports